import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConfirmationRegisterComponent } from 'extPafComponents/confirmation-register/confirmation-register.component';
import { AuthGuard } from './auth/auth.guard';
import {SuppliersListComponent} from './ECRANS/TABLEAU_DE_BORD/user-dashboard/suppliers-list.component'
import { FolderSavedInfoComponent } from 'src/app/ECRANS/folder-saved-info/folder-saved-info.component';
import {FolderSentToValidationComponent} from './ECRANS/folder-sent-to-validation/folder-sent-to-validation.component';

import {  
  SupplierDetailsComponent,
  SupplierDescriptifComponent,
  SupplierAccountInfoComponent,
  SupplierKnowledgeComponent,
  SupplierRegulDocsComponent,
  SupplierQualityDocsComponent,
  AccidentologieComponent } from 'ngx-paf-common';
import { LoginCallbackComponent } from 'extPafComponents/login-callback/login-callback.component';
import { LoggedOutComponent } from './ECRANS/logged-out/logged-out.component';
import { ShouldLoginComponent } from './ECRANS/should-login/should-login.component';
import { HomeComponent } from 'extPafComponents/home/home.component';

const routes: Routes = [
  {path:'login/callback', component:LoginCallbackComponent},
  {path:'loggedout', component:LoggedOutComponent},
  {path:'renew-password', component: SuppliersListComponent, canActivate: [AuthGuard]},
  {path:'login-required', component:ShouldLoginComponent},
  {path:'home', component:HomeComponent},
  {path:'', redirectTo:'home', pathMatch:'full'},
  {path:'suppliers', component: SuppliersListComponent, canActivate: [AuthGuard]},
  {path:'folder-saved-info', component: FolderSavedInfoComponent, canActivate: [AuthGuard]},
  {path:'folder-sent-to-validation', component: FolderSentToValidationComponent, canActivate: [AuthGuard]},
  {path:'supplier-details/:id', component: SupplierDetailsComponent, canActivate: [AuthGuard]},
  {path:'supplier-details/:id/initial-tab/:initialTab', component: SupplierDetailsComponent, canActivate: [AuthGuard]},
  {path:'supplier-descriptif',component:SupplierDescriptifComponent, outlet:'supplierDetailOutlet', canActivate: [AuthGuard]},
  {path:'supplier-account-info',component:SupplierAccountInfoComponent, outlet:'supplierDetailOutlet', canActivate: [AuthGuard]},
  {path:'supplier-knowledge',component:SupplierKnowledgeComponent, outlet:'supplierDetailOutlet', canActivate: [AuthGuard]},
  {path:'supplier-regul-docs',component:SupplierRegulDocsComponent, outlet:'supplierDetailOutlet', canActivate: [AuthGuard]},
  {path:'supplier-quality-docs',component:SupplierQualityDocsComponent, outlet:'supplierDetailOutlet', canActivate: [AuthGuard]},
  {path:'accidentologie',component:AccidentologieComponent, outlet:'accidentologieOutlet', canActivate: [AuthGuard]},
  {path:'confirmation-register/:id',component:ConfirmationRegisterComponent, canActivate: [AuthGuard]}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
